import { webFetch } from "utilities/webFetch";
import config from "utilities/config";

export enum AutomaticAppointmentStatus {
  None = "None",
  InitialMessageQueued = "InitialMessageQueued",
  InitialMessageSent = "InitialMessageSent",
  WebsiteVisit_EmailLink = "WebsiteVisit_EmailLink",
  WebsiteVisit_SmsLink = "WebsiteVisit_SmsLink",
  Canceled_Timeout = "Canceled_Timeout",
  Canceled_StatusChange = "Canceled_StatusChange",
  Completed_DateChosen = "Completed_DateChosen",
  Completed_CallMe = "Completed_CallMe",
};

export interface AutomaticAppointmentDto {
  appointmentInformation: AutomaticAppointmentInformation,
  availableAppointmentDates: AutomaticAppointmentTimeSlot[],
}

export interface AutomaticAppointmentInformation {
  policyHolderName: string,
    address: string,
    company: string,
    logoUrl: string,
    agent: string,
    apptDate?: string,
    apptTimeCode?: string,
    appointmentStatus: AutomaticAppointmentStatus,
    isAppraisal: boolean,
    isWithinCallCenterHours: boolean,
    muellerPhoneNumber: string,
    isCallCenterEligible: boolean,
    hasAppointmentSet: boolean,
}

export interface AutomaticAppointmentTimeSlot {
  date: string,
  appointmentTimeRangeCode: string,
}

interface AutomaticAppointmentSubmit {
  callMeRequested?: boolean,
  dateSelected?: string,
  timeRangeCode?: string,
}

const baseUrl = "automatic-appointment";

export const getAppointmentInformation = (workItemId: string, campaign: string, routeKey: string, onSuccess: (data: AutomaticAppointmentDto) => void) => {
  if(config.env === "local" && workItemId === "00000000-0000-0000-0000-000000000000") {
    onSuccess(fakeAppointmentInformation);
  }
  else {
    let url = `/${baseUrl}/${workItemId}/${campaign}`;
    if(routeKey)
      url = `${url}/${routeKey}`;

    webFetch({
      url: url,
      method: "GET",
      onSuccess: onSuccess,
    });
  }
}

export const postAppointmentSelection = (workItemId: string, campaign: string, routeKey: string, body: AutomaticAppointmentSubmit, onSuccess: () => void) => {
  let url = `/${baseUrl}/${workItemId}/${campaign}`;
  if(routeKey)
    url = `${url}/${routeKey}`;
  
  webFetch({
    url: url,
    method: "POST",
    body: body,
    onSuccess: onSuccess,
  })
};

// local mocks
const fakeAppointmentInformation: AutomaticAppointmentDto = {
  appointmentInformation: {
    policyHolderName: "Fake Policyholder",
    address: "63 Main Street",
    company: "Mueller Reports",
    logoUrl: "",
    agent: "Secret Agent Man, SECRET... AAAaaAAGENT MAAAN",
    apptDate: null,
    apptTimeCode: null,
    appointmentStatus: AutomaticAppointmentStatus.WebsiteVisit_SmsLink,
    isAppraisal: false,
    isWithinCallCenterHours: true,
    isCallCenterEligible: true,
    muellerPhoneNumber: "1-800-555-3455",
    hasAppointmentSet: true,
  },
  availableAppointmentDates: [
    { date: new Date().toISOString().split("T")[0], appointmentTimeRangeCode: "MORNING_EXTENDED"},
    { date: new Date().toISOString().split("T")[0], appointmentTimeRangeCode: "AFTERNOON_EXTENDED"},
  ]
};